import { render, staticRenderFns } from "./CorVeiculo.vue?vue&type=template&id=392a14a6"
import script from "./CorVeiculo.vue?vue&type=script&lang=js"
export * from "./CorVeiculo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports